<template>
  <div class="tw-flex tw-items-center tw-flex-wrap tw-mb-10 md:tw-mb-14 last:tw-mb-0" no-gutters :data-index="index">
    <div class="tw-basis-full md:tw-basis-1/3 md:tw-pr-12 tw-self-center">
      <NuxtImg :src="imgSrc" class="tw-rounded-2xl tw-object-cover tw-w-[420px] tw-max-height-[280px]" @click.native="onClick" />
    </div>
    <div class="tw-basis-full md:tw-basis-2/3 tw-py-2 tw-flex tw-flex-col tw-text-accent md:tw-py-4">
      <p class="tw-flex tw-flex-wrap tw-mb-2 tw-leading-7 md:tw-leading-10">
        <template v-if="Array.isArray(article.category)">
          <span
            class="tw-bg-primary tw-font-semibold tw-text-sm tw-rounded-[6px] tw-inline-flex tw-leading-7 tw-self-center tw-px-3 tw-mr-2 md:tw-text-lg md:tw-leading-8"
            v-for="item in article.category"
          >
            {{ typeof item === 'string' ? item : item.$.term }}
          </span>
        </template>
      </p>
      <h3 class="tw-font-bold tw-text-[1.75rem] tw-leading-9 tw-my-2 md:tw-text-3xl md:tw-my-4">{{ article.title }}</h3>
      <p class="tw-line-clamp-4 tw-text-lg tw-leading-8 md:tw-line-clamp-2">{{ article.description }}</p>
      <p class="md:tw-mt-4">
        <a
          :href="props.article.path?.replace(/^\/articles\/repost/, '/newsroom') || '#'"
          variant="text"
          class="tw-text-lg tw-text-primary tw-underline tw-underline-offset-2 hover:tw-text-black"
          @click.prevent="onClick"
          >Read Article</a
        >
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps(['article', 'index'])
  const emit = defineEmits<{
    'view-article': [{ slug: string }]
  }>()

  const imgSrc = computed(() => {
    if (typeof props.article?.image === 'string') {
      return props.article?.image
    } else {
      return props.article?.image?.src
    }
  })

  const onClick = async () => {
    // 从 path 中提取 slug，移除 '/articles/repost/' 前缀
    const slug = props.article.path?.replace('/articles/repost/', '')?.split('/') || []

    emit('view-article', { slug })
  }
</script>

<style scoped></style>
